module.exports = __webpack_public_path__ + "img/goldregen-2020-117.bac3241f.jpg";